<template>
  <component
    :is="type"
    v-if="typeof children === 'string'"
    class="def-title"
    :class="{
      [`def-title-${result}`]: !!result,
      'def-title-center': center,
    }"
  >
    {{ children }}
  </component>
  <div v-else>use only html tag in title</div>
</template>

<script lang="ts" setup>
import { useSlots, Slots } from 'vue';

const props = defineProps<{
  result: number | string;
  center?: boolean;
}>();

const slots: Slots = useSlots();

const { children, type } = slots.default()[0];
</script>

<style lang="scss" scoped>
.def-title {
  margin-bottom: 24px;
  :deep(> *) {
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--text-colour-primary);
  }
}
.def-title-1 {
  margin-bottom: 16px;
  :deep(> *) {
    font-size: rem(20);
    @include point-md {
      font-size: rem(24);
    }
    @include point-lg {
      font-size: rem(32);
    }
  }
}
.def-title-2 {
  margin-bottom: 16px;
  :deep(> *) {
    font-size: rem(18);
    @include point-lg {
      font-size: rem(24);
    }
  }
}
.def-title-3 {
  margin-bottom: rem(12);
  :deep(> *) {
    font-size: rem(14);
    @include point-md {
      font-size: rem(16);
    }
    @include point-lg {
      font-size: rem(18);
    }
  }
}
.def-title-4 {
  margin-bottom: 14px;
  //:deep(> *) {
  font-size: rem(14);
  @include point-md {
    font-size: rem(16);
  }
  //}
}
.def-title-5 {
  margin-bottom: rem(12);
  :deep(> *) {
    font-size: rem(12);
    @include point-md {
      font-size: rem(14);
    }
  }
}
.def-title-6 {
  margin-bottom: 10px;
  :deep(> *) {
    font-size: rem(16);
  }
}
.def-title-center {
  text-align: center;
}
</style>
